// tslint:disable:no-bitwise
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import "pixi.js";
import { utilGrid } from "../grid/utilGrid";
import { utilNumber } from "../utilNumber";
var defaultOptions = {
    fillAlpha: 1,
    fillColor: -1,
    lineColor: 0,
    lineWidth: 0,
    originMarkColor: -1,
    sizeX: 1,
    sizeY: 1,
    volume: 0,
    x: 0,
    y: 0,
};
var UtilDrawGrid = /** @class */ (function () {
    function UtilDrawGrid() {
        var _this = this;
        this.draw = function (target, options) {
            if (options === void 0) { options = defaultOptions; }
            var opts = __assign({}, defaultOptions, options);
            var pos;
            // Draw fill
            if (opts.fillColor !== -1) {
                _this.drawObject(target, opts);
            }
            // Draw grid
            if (opts.lineWidth > 0) {
                target.lineStyle(opts.lineWidth, opts.lineColor);
                for (var i = 0; i < opts.sizeX + 1; i++) {
                    pos = utilGrid.mapToScreen(opts.x + i, opts.y);
                    target.moveTo(pos.x, pos.y);
                    pos = utilGrid.mapToScreen(opts.x + i, opts.y + opts.sizeY);
                    target.lineTo(pos.x, pos.y);
                }
                for (var i = 0; i < opts.sizeY + 1; i++) {
                    pos = utilGrid.mapToScreen(opts.x, opts.y + i);
                    target.moveTo(pos.x, pos.y);
                    pos = utilGrid.mapToScreen(opts.x + opts.sizeX, opts.y + i);
                    target.lineTo(pos.x, pos.y);
                }
            }
            // Draw origin
            if (opts.originMarkColor !== -1) {
                pos = utilGrid.mapToScreen(opts.x, opts.y);
                target
                    .beginFill(opts.originMarkColor)
                    .drawCircle(pos.x, pos.y, 2)
                    .endFill();
            }
            return target;
        };
        this.drawObjectOutline = function (target, options) {
            if (options === void 0) { options = defaultOptions; }
            var opts = __assign({}, defaultOptions, options);
            target.lineStyle(opts.lineWidth, opts.lineColor);
            _this.drawObject(target, opts);
            // Draw origin
            if (opts.originMarkColor !== -1) {
                var pos = utilGrid.mapToScreen(opts.x, opts.y);
                target
                    .beginFill(opts.originMarkColor)
                    .drawCircle(pos.x, pos.y, 3)
                    .endFill();
            }
            target.cacheAsBitmap = true;
            return target;
        };
        this.drawObject = function (target, opts, shadeColors) {
            if (shadeColors === void 0) { shadeColors = true; }
            // Draw top
            _this.drawFill(target, opts.fillColor, opts.fillAlpha, [
                { x: opts.x + opts.volume, y: opts.y + opts.volume },
                { x: opts.x + opts.sizeX + opts.volume, y: opts.y + opts.volume },
                { x: opts.x + opts.sizeX + opts.volume, y: opts.y + opts.sizeY + opts.volume },
                { x: opts.x + opts.volume, y: opts.y + opts.sizeY + opts.volume },
                { x: opts.x + opts.volume, y: opts.y + opts.volume },
            ]);
            // Draw left
            _this.drawFill(target, shadeColors ? _this.shadeColor(opts.fillColor, 0x306000) : opts.fillColor, opts.fillAlpha, [
                { x: opts.x, y: opts.y },
                { x: opts.x + opts.volume, y: opts.y + opts.volume },
                { x: opts.x + opts.volume, y: opts.y + opts.sizeY + opts.volume },
                { x: opts.x, y: opts.y + opts.sizeY },
                { x: opts.x, y: opts.y },
            ]);
            // Draw right
            _this.drawFill(target, shadeColors ? _this.shadeColor(opts.fillColor, 0x406040, -1) : opts.fillColor, opts.fillAlpha, [
                { x: opts.x, y: opts.y },
                { x: opts.x + opts.volume, y: opts.y + opts.volume },
                { x: opts.x + opts.sizeX + opts.volume, y: opts.y + opts.volume },
                { x: opts.x + opts.sizeX, y: opts.y },
                { x: opts.x, y: opts.y },
            ]);
            return target;
        };
        this.drawFill = function (target, color, alpha, points) {
            target.beginFill(color, alpha);
            _this.iterateOnPoints(target, points);
            target.endFill();
            return target;
        };
        this.drawOutline = function (target, lineWidth, color, alpha, points) {
            target.lineStyle(lineWidth, color, alpha);
            _this.iterateOnPoints(target, points);
            target.endFill();
            return target;
        };
        this.iterateOnPoints = function (target, points) {
            var pos;
            points.forEach(function (p, idx) {
                pos = utilGrid.mapToScreen(p.x, p.y);
                if (idx === 0) {
                    target.moveTo(pos.x, pos.y);
                }
                else {
                    target.lineTo(pos.x, pos.y);
                }
            });
            return target;
        };
        this.shadeColor = function (color, addition, modifier) {
            if (modifier === void 0) { modifier = 1; }
            var R = color >> 16;
            var G = (color >> 8) & 0x00ff;
            var B = color & 0x0000ff;
            var aR = (addition >> 16) * modifier;
            var aG = ((addition >> 8) & 0x00ff) * modifier;
            var aB = (addition & 0x0000ff) * modifier;
            return (utilNumber.clamp(B + aB, 0, 0xff) |
                (utilNumber.clamp(G + aG, 0, 0xff) << 8) |
                (utilNumber.clamp(R + aR, 0, 0xff) << 16));
        };
    }
    return UtilDrawGrid;
}());
export var utilDrawGrid = new UtilDrawGrid();



//////////////////
// WEBPACK FOOTER
// ./src/utils/graphics/utilDrawGrid.ts
// module id = 428
// module chunks = 3